import React, { useEffect, useRef, useState } from "react";

const ProductActions = (props) => {
  const {
    classes,
    item,
    variants,
    isActive,
    isCompareActive,
    onWishlist,
    onCompare,
    onCopyLink,
    copyText,
  } = props;
  const variantId = variants && variants.id ? variants.id : "";
  const itemValue = item && item.value ? item.value : "";
  const url = `https://sunnydiamonds.com/${itemValue}?variant_id=${variantId}`;
  const dropRef = useRef(null);
  const [isDropOpen, setIsDropOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (dropRef.current && window.UIkit) {
        const drop = window.UIkit.drop(dropRef.current);
        if (drop) {
          drop.hide(false);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, []);

  useEffect(() => {
    const el = dropRef.current;
    if (!el || !window.UIkit) return;
    const onShow = () => setIsDropOpen(true);
    const onHide = () => setIsDropOpen(false);
    window.UIkit.util.on(el, "show", onShow);
    window.UIkit.util.on(el, "hide", onHide);
    return () => {
      window.UIkit.util.off(el, "show", onShow);
      window.UIkit.util.off(el, "hide", onHide);
    };
  }, []);

  return (
    <div className={classes.product_actions}>
      <a
        role="button" tabIndex={0}
        className={classes.action_btn}
        onClick={() => onCompare(item)}
      >
        {isCompareActive ?
          // Active Icon 
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="2.80469" y="3.16406" width="5.64017" height="5.64017" fill="#732257" stroke="#732257" strokeLinecap="square" strokeLinejoin="round" />
            <rect x="13.5586" y="3.16406" width="5.64017" height="5.64017" fill="#732257" stroke="#732257" strokeLinecap="square" strokeLinejoin="round" />
            <line x1="2.82422" y1="11.5757" x2="19.1787" y2="11.5757" stroke="#732257" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M11.0052 12.0757L14.3698 18.7236H7.64062L11.0052 12.0757Z" fill="#732257" stroke="#732257" strokeLinecap="square" strokeLinejoin="round" />
          </svg> :
          // DEfault Icon 
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="2.80469" y="3.16406" width="5.64017" height="5.64017" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
            <rect x="13.5586" y="3.16406" width="5.64017" height="5.64017" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
            <line x1="2.82422" y1="11.5757" x2="19.1787" y2="11.5757" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M11.0052 12.0757L14.3698 18.7236H7.64062L11.0052 12.0757Z" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
          </svg>}
      </a>
      <a
        role="button" tabIndex={0}
        className={classes.action_btn}
        onClick={() => onWishlist(item)}
      >
        {isActive ? (
          // Active Icon
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M19.4797 9.5184C19.4706 7.19386 18.251 5.00779 15.8467 4.23322C14.1957 3.70045 12.3973 3.99673 11.0006 6.00191C9.60394 3.99673 7.80555 3.70045 6.15456 4.23322C3.74992 5.00788 2.53035 7.19436 2.52153 9.5192C2.49929 14.1426 10.9994 19.3715 10.9994 19.3715L11.0006 19.371L11.0018 19.3715C11.0018 19.3715 19.5025 14.1422 19.4797 9.5184Z" fill="#732257" stroke="#732257" strokeLinecap="square" />
          </svg>
        ) : (
          // Default Icon 
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M19.4797 9.5184C19.4706 7.19386 18.251 5.00779 15.8467 4.23322C14.1957 3.70045 12.3973 3.99673 11.0006 6.00191C9.60394 3.99673 7.80555 3.70045 6.15456 4.23322C3.74992 5.00788 2.53035 7.19436 2.52153 9.5192C2.49929 14.1426 10.9994 19.3715 10.9994 19.3715L11.0006 19.371L11.0018 19.3715C11.0018 19.3715 19.5025 14.1422 19.4797 9.5184Z" stroke="black" strokeLinecap="square" />
          </svg>
        )}
      </a>
      <div>
        <a role="button" tabIndex={0} className={classes.action_btn}>
          {isDropOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path d="M15.7986 7.53378C17.2342 7.53378 18.398 6.36998 18.398 4.93437C18.398 3.49876 17.2342 2.33496 15.7986 2.33496C14.363 2.33496 13.1992 3.49876 13.1992 4.93437C13.1992 6.36998 14.363 7.53378 15.7986 7.53378Z" fill="#732257" stroke="#732257" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5.40019 13.5992C6.8358 13.5992 7.9996 12.4354 7.9996 10.9998C7.9996 9.56419 6.8358 8.40039 5.40019 8.40039C3.96458 8.40039 2.80078 9.56419 2.80078 10.9998C2.80078 12.4354 3.96458 13.5992 5.40019 13.5992Z" fill="#732257" stroke="#732257" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M15.7986 19.6646C17.2342 19.6646 18.398 18.5008 18.398 17.0652C18.398 15.6296 17.2342 14.4658 15.7986 14.4658C14.363 14.4658 13.1992 15.6296 13.1992 17.0652C13.1992 18.5008 14.363 19.6646 15.7986 19.6646Z" fill="#732257" stroke="#732257" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M7.64453 12.3076L13.5625 15.7562" stroke="#732257" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M13.5539 6.24219L7.64453 9.69073" stroke="#732257" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path d="M15.7986 7.53378C17.2342 7.53378 18.398 6.36998 18.398 4.93437C18.398 3.49876 17.2342 2.33496 15.7986 2.33496C14.363 2.33496 13.1992 3.49876 13.1992 4.93437C13.1992 6.36998 14.363 7.53378 15.7986 7.53378Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5.40019 13.5992C6.8358 13.5992 7.9996 12.4354 7.9996 10.9998C7.9996 9.56419 6.8358 8.40039 5.40019 8.40039C3.96458 8.40039 2.80078 9.56419 2.80078 10.9998C2.80078 12.4354 3.96458 13.5992 5.40019 13.5992Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M15.7986 19.6646C17.2342 19.6646 18.398 18.5008 18.398 17.0652C18.398 15.6296 17.2342 14.4658 15.7986 14.4658C14.363 14.4658 13.1992 15.6296 13.1992 17.0652C13.1992 18.5008 14.363 19.6646 15.7986 19.6646Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M7.64453 12.3076L13.5625 15.7562" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M13.5539 6.24219L7.64453 9.69073" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </a>
        <div
          ref={dropRef}
          className="uk-card uk-card-default"
          data-uk-drop="mode: click"
        >
          <div className="uk-card-header p-3">
            <div className="uk-grid-small uk-flex-middle" data-uk-grid>
              <div className="uk-width-expand">
                <h3 className="uk-margin-remove-bottom fw-bold">
                  Social Share
                </h3>
                <p className="uk-text-meta uk-margin-remove-top text-muted">
                  Share this link via
                </p>
              </div>
            </div>
          </div>
          <hr className="uk-margin-remove" />
          <div className="uk-card-body p-3">
            <div className="uk-flex uk-flex-between">
              <div>
                <a
                  href={
                    "https://www.facebook.com/sharer/sharer.php?u=" +
                    encodeURIComponent(
                      "https://sunnydiamonds.com/" +
                      item.value +
                      "?variant_id=" +
                      variants.id,
                    )
                  }
                  target="_blank"
                  className="rounded-circle share-facebook d-flex justify-content-center align-items-center"
                >
                  <span data-uk-icon="facebook"></span>
                </a>
              </div>
              <div>
                <a
                  href={
                    "https://x.com/intent/tweet?url=https://sunnydiamonds.com/" +
                    item.value
                  }
                  target="_blank"
                  className="rounded-circle share-twitter d-flex justify-content-center align-items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="black"
                  >
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
              </div>
              <div>
                <a
                  href={`https://wa.me/?text=${encodeURIComponent(url)}`}
                  data-action="share/whatsapp/share"
                  target="_blank"
                  className="rounded-circle share-whatsapp d-flex justify-content-center align-items-center"
                >
                  <span data-uk-icon="whatsapp"></span>
                </a>
              </div>
              <div>
                <a
                  onClick={onCopyLink}
                  className="rounded-circle share-copy d-flex justify-content-center align-items-center"
                >
                  {copyText && (
                    <span className={classes.copy_text}>{copyText}</span>
                  )}

                  <span data-uk-icon="copy"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductActions;
